import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddressSelectorComponent } from './address-selector.component';
import { Address } from '../organisation.model';
import { ModalService } from '../../../core/modal/modal.service';

@Directive({
  selector: '[taxOpenAddressSelector]',
})
export class OpenAddressSelectorDirective implements OnDestroy {
  // @ts-ignore
  @Input() taxOpenAddressSelector: Address | null;

  @Output() newAddress: EventEmitter<Address> = new EventEmitter<Address>();

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private modalService: ModalService,
  ) {
  }

  @HostListener('click')
  openModal(): void {
    this.modalService
      .openOld(AddressSelectorComponent, {
        address: this.taxOpenAddressSelector,
      }, {
        width: '740px',
      })
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe((address) => {
        this.newAddress.emit(address);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
